export default "__VITE_ASSET__C7njP4Q2__"